import { SettingsTrustedIpsDto } from '@sr/dto';
import { FormikErrors } from 'formik';
import { FormTools } from 'utils/form-tools';

export type FormData = { enabled: boolean; trustedIps: string[]};

export const formTools: FormTools<SettingsTrustedIpsDto & { id: number }, SettingsTrustedIpsDto, SettingsTrustedIpsDto, FormData> = {
  fromDto: (dto: SettingsTrustedIpsDto): FormData => {
    return { enabled: dto.enabled, trustedIps: dto.trustedIps || [] };
  },
  toCreateDto: (formData: FormData): SettingsTrustedIpsDto => {
    return {
      trustedIps: formData.trustedIps.filter(ip => ip.trim() !== ''),
      enabled: formData.enabled
    };
  },
  toUpdateDto: () => {
    throw new Error('Not implemented.');
  },
  validate: (values: FormData) => {
    const errors: FormikErrors<FormData> = {};
    return errors;
  },
  emptyValues: () => ({ enabled: false, trustedIps: [], id: 1 })
};
